<template>
    <tr>
        <td>
            <div class="flexo">
                <span v-tooltip="$t('analysis:transaction:details')">
                    <a :href="`/market/transaction/${item.transaction_id}/details`" class="open-modal">
                        #{{ item.transaction_id }}
                    </a>
                </span>
                <a v-if="item.transaction_volume > 1" :href="`/market/transaction/${item.transaction_id}/details`" class="open-modal text-white">
                    <span
                        class="label label-rouded label-info"
                        v-tooltip="$t('analysis:transaction:contains_more_re')"
                    >
                        {{ item.transaction_volume }}
                    </span>
                </a>
            </div>
        </td>
        <td>
            <div class="re-key font-medium" :v-tooltip="$t('widgets:modal:real_estate_details')">
                <a :href="`/amas/real_estate/${item.re_key}/details`" class="open-modal">
                    {{ item.address || item.re_key || "/" }}
                </a>
            </div>
            <span class="text-muted">{{ item.get_component_type_display }}</span>
        </td>
        <td>
            {{ item.transaction_type_display }}
        </td>
        <td>
            {{ item.transaction_date }}
        </td>
        <td>
            <div class="flexo">
                <div class="text-info">
                    <span v-tooltip="$t('analysis:ct:transaction_value_contract_price')" class="cursor-help">
                        {{item.transaction_amount_gross|formatCurrency(0)}}
                    </span>
                </div>
                <div v-if="item.transaction_tax || item.component_tax">
                    <small>{{$t("general:with")}} {{$t("general:vat")}}</small>
                </div>

                <span v-if="item.transaction_amount_m2">
                    <span class="text-primary">
                        {{item.transaction_amount_m2|formatCurrencym2(0)}}
                    </span>
                    <div v-if="item.transaction_tax || item.component_tax">
                        <small>{{$t("general:with")}} {{$t("general:vat")}}</small>
                    </div>
                </span>
                <span v-else-if="item.estimated_amount_m2" class="text-secondary">
                    {{item.estimated_amount_m2|formatCurrencym2(0)}}
                </span>
                <span v-else class="text-secondary">
                    /
                </span>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    name: "PropertyTransactionHistoryTableRow",
    props:  {
        item: Object,
    },
}
</script>